import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Heading from 'app/components/shared/Heading';
import { BibSlideContainer } from 'app/components/bibs/shared/BibSlide';
import { selectRelatedTitlesForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';

import './RelatedTitles.scss';

export default function RelatedTitles({ handleRelatedTitleClick }) {
  const relatedTitles = useSelector(selectRelatedTitlesForCurrentBib);

  if (relatedTitles.size > 0) {
    return (
      <div className="cp-related-titles">
        <div className="heading">
          <Heading tagName="h3" size="medium" variant>
            <FormattedMessage id="related_titles" />
          </Heading>
        </div>
        <div className="items">
          {relatedTitles.map(relatedTitle => (
            <BibSlideContainer
              key={relatedTitle.get('metadataId')}
              metadataId={relatedTitle.get('metadataId')}
              handleClick={() => handleRelatedTitleClick(relatedTitle)}
            />
          ))}
        </div>
      </div>
    );
  }

  return null;
}

RelatedTitles.propTypes = {
  handleRelatedTitleClick: PropTypes.func
};
